import { QueryClient } from "@tanstack/react-query"

const getStatus = (error: unknown): number | undefined => {
    return (error as { status?: number })?.status;
}

const isClientError = (error: unknown): boolean => {
    const status = getStatus(error);
    return status !== undefined && status >= 400 && status < 500;
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => !isClientError(error) && failureCount < 3,
        },
        mutations: {
            retry: (failureCount, error) => !isClientError(error) && failureCount < 3,
        },
    },
})
